import { FormControlLabel, styled } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import { Form, Checkbox, Typography } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

import { UserEmailOptInDto } from '../../dto/UserEmailOptInDto';

export type EmailOptInProps = {
  reversed?: boolean;
};

const StyledFormControlLabel = styled(FormControlLabel)({
  '&.MuiFormControlLabel-labelPlacementStart': {
    justifyContent: 'space-between',
    width: '100%',
  },
});

export const EmailOptIn = ({ reversed }: EmailOptInProps) => {
  const { control,  } = useFormContext<UserEmailOptInDto>();
  const { t } = useI18n();

  return (
    <Form.FieldContainer>
      <Typography>
        <Controller
          control={control}
          name="marketingAccepted"
          render={({ field: { onChange, value } }) => (
            <StyledFormControlLabel
              control={
                <Checkbox
                  checked={value}
                  onChange={onChange}
                  inputProps={{
                    // @ts-expect-error https://github.com/mui/material-ui/issues/20160
                    'data-testid': 'marketing-agreement-test-id',
                  }}
                />
              }
              labelPlacement={reversed ? 'start' : 'end'}
              label={<Typography>{t('users:auth.email_opt_in')}</Typography>}
            />
          )}
        />
      </Typography>
    </Form.FieldContainer>
  );
};
